import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { getPaletteAsRawColors } from 'owa-theme';
import { IButtonStyles } from 'office-ui-fabric-react/lib/Button';

export default function getCalendarThemedButtonStyle(colorScheme: ColorScheme): IButtonStyles {
    let optionalButtonStyles: IButtonStyles = {
        root: {
            backgroundColor: getPaletteAsRawColors().white,
            color: colorScheme.accessibleText.msColorWhiteBackground,
        },

        rootHovered: {
            backgroundColor: colorScheme.calLighter,
            color: colorScheme.calDark,
        },

        rootPressed: {
            backgroundColor: colorScheme.calLighter,
            color: colorScheme.calDarker,
        },

        rootExpanded: {
            backgroundColor: colorScheme.calLighter,
            color: colorScheme.calDarker,
        },
    };

    return optionalButtonStyles;
}
